import { render, staticRenderFns } from "./DateMeal-confirm.vue?vue&type=template&id=1f873c62&scoped=true&"
import script from "./DateMeal-confirm.vue?vue&type=script&lang=js&"
export * from "./DateMeal-confirm.vue?vue&type=script&lang=js&"
import style0 from "./DateMeal-confirm.vue?vue&type=style&index=0&id=1f873c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f873c62",
  null
  
)

export default component.exports